import {API_DOMAIN, API_PATH, STORE} from '../common/Model';

export default class Popularity {
	constructor(_config) {
		this.config = _config;
		this.serviceEnv = _config.serviceEnv.toUpperCase() || 'LIVE';
		this.serviceApiUrl = API_DOMAIN.COMMUNITY[this.serviceEnv];

		// // {\"tabActive\":{\"popularity\":false,\"myfeed\":true},\"tabPopularity\":{\"list\":[{\"isActive\":false}]}
		this.alias = _config.tabConfig.tabPopularity.list; // 인기글 불러올 게시판을 운영툴에서 지정
		this.container = $('.home-popularity');

	}

	init() {
		const _alias= this.alias;
		if( this.container.is(':empty') ) {

			let containerTmpl =`
				${_alias.map( item => {
					if(item.isActive) return `<section class="popularity-wrapper" data-content-id="${item.weightAlias}"></section>`;
				}).join('')}
			`;

			this.container.html(containerTmpl);
			this.get();

		}

		this.addEvent();

	}

	get() {

		const _url = this.serviceApiUrl;
		const _alias= this.alias;

		// 최근 5개월 동안 게시글
		const _date = new Date(userData.now);
		_date.setMonth(_date.getMonth() - 5);
		const _fromDate = `${_date.toISOString().split('.')[0]}`;

		// Popularity BoardAlias List
		$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${_url}/tricksterm/popularity`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
		});

		_alias.map( item => {
			let _ajaxUrl, _ajaxParam, _ajaxData;

			if(! item.isActive) return;

			if(item.weightAlias == 'qnanknowhow') {
				_ajaxUrl = `/api/ncommunity/article/listArticleEntries/qnanknowhow`;
				// _ajaxUrl = `/board/qnanknowhow/article/search/moreArticle`
				_ajaxParam = {};
				_ajaxData = {
					summary: false,
						moreSize: 18,
						previousArticleId: 0,
						categoryId: 0,
				};
			} else {
				_ajaxUrl = `${_url}/tricksterm/popularity/${item.weightAlias}/list`;
				_ajaxParam = {
					'mergeJobRef' : '5f056ba80e7721000152492b',
					'from' : _fromDate ,
					'to' : '2029-05-01T23:10:01'
				};
				_ajaxData = {};
			}

			$.ajax({
				dataType: "json",
				type: "GET",
				headers: {
					'Content-Type': 'application/json', 'Accept': 'application/json'
				},
				data: _ajaxData,
				params: _ajaxParam,
				url: _ajaxUrl
			})
			.fail( xhr => console.log('오류가 발생했습니다.') )
			.done(( data ) => {
				let _title = item.icon ? `<img src="${item.icon}" width=20 height=20><h3>${item.title}</h3>` : `<h3>${item.title}</h3>`;
				this.render( data, item.weightAlias, _title);
				STORE.data[item.weightAlias] = data;
				STORE.title[item.weightAlias] = _title;
			});
		});
	}


	render(data, alias, title) {
		// console.log('## [homePopularity.js] render() data : ' , data , ' | alias: ', alias , ' | title: ', title);
		let conainer = $(`[data-content-id=${alias}]`);
		let _List = (alias == 'qnanknowhow') ? data.contentList : data.articleList;
		if(! data || ! _List) return;
		let tmpl = this.templ(_List, alias, title);
		if(data && _List.length > 0) conainer.append( tmpl );
	}

	templ(listData, alias, title){
		// console.log('## [homePopularity.js] templ() data : ' , listData );
		return `
		<header class="popularity-header">
			${title}
		</header>
		<article class="popularity-list">
			${listData.map( (item, index) => {
				if(index<18) return this.listTempl(item, alias);
			}).join('')}
		</article>
		<footer class="popularity-button">
			<a class="button-more" href="/board/${alias}/list">더보기</a>
		</footer>`;
	}

	listTempl(item, alias) {
		const _thumb = (item.thumbnailUrl) ? `<div class="popularity-thumb"><img src="${item.thumbnailUrl}"></div>` : ``;
		const _info = (alias == 'topScrap') ? `<span class="category">${item.category.categoryName}</span> <span class="bookmark"><i class="icon-bookmark"></i>${item.scrapCount}</span>` : (alias=='qnanknowhow') ? `<span class="writer">${item.writer.loginUser.name}</span> <span class="hit">조회 <strong>${item.reactions.viewCount}</strong></span> <span class="comment"><i class="icon-comment"></i>${item.reactions.commentCount}</span>`: `<span class="writer">${item.writer.loginUser.name}</span> <span class="hit">조회 <strong>${item.hitCount}</strong></span> <span class="comment"><i class="icon-comment"></i>${item.commentCount}</span>`;

		return `
		<div class="popularity-item">
			<a class="popularity-link" href="${item.url}">
				<div class="popularity-text">
					<div class="popularity-title">${item.title}</div>
					<div class="popularity-info">
					${_info}
					</div>
				</div>
				${_thumb}
			</a>
		</div>`;
	}

	addEvent() {

	}


}